/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { AlertBar } from '@blend/enterprise-components';

export namespace Toast {
  export interface Props {
    dismiss: () => void;
    message: string;
    theme: AlertBar.ThemeType;
  }
}

// The current Toast implementation is just a simple dismissable toast.
// TODO: Add custom confirm/cancel props as needed
/**
 * @param props.message
 * @returns
 */
export const Toast: React.FC<Toast.Props> = ({ message, theme, dismiss }) => (
  <AlertBar
    confirmProps={{
      confirmText: 'Dismiss',
      onConfirm: () => dismiss(),
    }}
    message={message}
    theme={theme}
  />
);
